import { useMemo, useState } from 'react';
import { useRequest } from 'ahooks';
import { getFeeInfo } from '@/services/user';
import { MediaFeeMedium } from '@/interface';

export default () => {
  const [feeInfo, setFeeInfo] = useState<API.MediaFeeInfo[]>();

  const googleServiceFee = useMemo(() => {
    return feeInfo?.find(item => item?.media === MediaFeeMedium.GOOGLE);
  }, [feeInfo]);

  const { loading, run: getFeeInfoRequest } = useRequest(getFeeInfo, {
    manual: true,
    onSuccess(res) {
      setFeeInfo(res?.data ?? []);
    },
    onError() {
      setFeeInfo(undefined);
    },
  });

  return {
    loading,
    /** 媒体服务费信息 */
    feeInfo,
    /** 谷歌服务费信息 */
    googleServiceFee,
    /** 获取媒体服务费信息
     *
     * 注意: 这是一个同步方法, 不能在函数组件中直接调用
     *
     * 你应该在 useEffect 或者 事件函数中调用
     */
    getFeeInfoRequest,
  };
};
